import * as moment from 'moment';

export function getCurrentDateForView(): string {
  const effectiveDate = new Date();
  const month: number = effectiveDate.getMonth() + 1;
  return effectiveDate.getDate() + '/' + month + '/' + effectiveDate.getFullYear();
}

export function getCurrentDateForAPI(): string {
  const effectiveDate = new Date();
  const month: number = effectiveDate.getMonth() + 1;
  return effectiveDate.getFullYear() + '/' + month + '/' + effectiveDate.getDate();
}



// WEBPACK FOOTER //
// /codebuild/output/src4156872633/src/src/app/shared/date-functions.ts